import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';

import { GlCategoryIconPickerComponent } from './gl-category-icon-picker.component';
import { RnplCommonModule } from 'common/src/modules';


@NgModule({
  declarations: [
    GlCategoryIconPickerComponent
  ],
  exports: [
    GlCategoryIconPickerComponent
  ],
  imports: [
    CommonModule,
    OverlayModule,
    RnplCommonModule,
  ],
})
export class GlCategoryIconPickerModule { }
